<template>
  <span>
    {{loopType}}
  </span>
</template>

<script>
export default {
  props: ['config', ],
  computed: {
    loopType(){
      let loopType = {
        1: '电流',
        2: '电流',
        3: '温度',
        4: '电压',
        5: '烟雾'
      }
      let loopTypeId = this.config.loop_type
      let loopSort = this.config.loop_sort;

      if(loopTypeId == 1){
        return '剩余电流'
      }
      if(loopTypeId == 5){
        return '烟雾'
      }
      let loopSortConfig = {
        1: 'A相',
        2: 'B相',
        3: 'C相',
        4: '箱体'
      }
      return loopSortConfig[loopSort] + ''+ loopType[loopTypeId]
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/component/base-loop-type.vue